export const T = {
  fr: {
    nav_discover: "Découvrir", nav_sessions: "Sessions", nav_messages: "Messages", nav_profile: "Profil",
    discover_search: "Tu cherches quoi aujourd'hui ?", discover_tagline: "Pas un date. Un vrai échange.",
    discover_empty: "On affine ton Swap.", discover_empty_sub: "Essaie d'enlever un filtre ou d'élargir la zone.",
    discover_empty_cta: "Créer une demande", discover_restart: "Recommencer",
    filter_all: "Tout", filter_offers: "Offres", filter_requests: "Demandes", filter_sessions: "Sessions",
    filter_profiles: "Profils", filter_clear: "Effacer", filter_apply: "Voir les résultats",
    filter_category: "Catégorie", filter_zone: "Zone", filter_format: "Format", filter_duration: "Durée",
    card_skip: "Passer", card_save: "Sauver", card_ask: "Demander", card_offer: "Proposer",
    card_join: "Rejoindre", card_view: "Voir profil",
    card_type_offer: "Offre", card_type_request: "Demande", card_type_session: "Session",
    card_match: "Match :",
    msg_received: "Reçus", msg_sent: "Envoyés", msg_active: "Actifs", msg_archived: "Archivés",
    msg_blur_hint: "Message flouté — toi qui choisis de l'ouvrir.",
    msg_reveal: "Lire le message", msg_accept: "Accepter", msg_decline: "Refuser",
    msg_block: "Bloquer", msg_report: "Signaler", msg_delete: "Supprimer",
    msg_pending_sent: "Demande envoyée. Tu pourras continuer si la personne répond.",
    msg_one_request: "Une seule demande. Pas de spam.",
    msg_placeholder: "Ton message (250 car. max)...",
    msg_empty_received: "Pas encore de demandes reçues.",
    msg_empty_sent: "Tu n'as pas encore envoyé de demande.",
    msg_empty_active: "Pas de conversations actives.",
    msg_status_pending: "En attente", msg_status_accepted: "Accepté", msg_status_declined: "Refusé",
    msg_status_revealed: "Ouvert", msg_status_blocked: "Bloqué",
    req_form_title: "Envoyer une demande", req_skill: "Skill concerné", req_goal: "Ton objectif",
    req_format: "Format", req_duration: "Durée", req_zone: "Zone", req_message: "Message",
    req_send: "Envoyer la demande", req_cancel: "Annuler",
    session_join: "Rejoindre", session_places: "place(s) restante(s)", session_full: "Complet",
    session_level: "Niveau", session_language: "Langue", session_host: "Organisé par",
    session_safety: "Lieu public ou en ligne — respect mutuel",
    session_filter_title: "Filtrer les sessions",
    profile_edit: "Modifier", profile_save: "Enregistrer", profile_preview: "Aperçu",
    profile_skills_offered: "Je propose", profile_skills_needed: "Je cherche",
    profile_availability: "Disponibilité", profile_bio: "Bio",
    profile_add_skill: "Ajouter un skill", profile_detail_placeholder: "Précision optionnelle...",
    profile_step_basics: "Infos", profile_step_skills: "Skills", profile_step_zones: "Zones",
    profile_step_preview: "Aperçu",
    safety_title: "Règles de la communauté",
    safety_tagline: "Pas un date. Un vrai échange. Choisis un skill, pas une personne.",
    landing_hero: "Échange des skills. Trouve ton coup de main. Commence à Talence.",
    landing_sub: "Une app locale pour proposer ce que tu sais faire, trouver ce dont tu as besoin et rejoindre des mini-sessions autour de toi.",
    landing_cta1: "Ouvrir Swap", landing_cta2: "Proposer un skill",
    landing_tagline: "Pas un date. Un vrai échange.",
    landing_how: "Comment ça marche", landing_examples: "Exemples d'échanges",
    landing_safety: "Sécurité", landing_local: "Pilote local",
    how_step1: "Choisis ce que tu cherches", how_step1_sub: "Skills, aide, activité, session...",
    how_step2: "Découvre des profils", how_step2_sub: "Quelqu'un qui propose ou qui cherche.",
    how_step3: "Envoie une demande", how_step3_sub: "Message structuré. Pas de spam.",
    how_step4: "Échange en vrai ou en ligne", how_step4_sub: "Lieu public, campus ou visio.",
    admin_title: "Administration — Modération",
    match_ready: "Swap possible", write_now: "Écrire maintenant", save_later: "Garder pour plus tard",
    request_sent: "Demande envoyée", around_you: "Autour de toi", suggestions: "Suggestions du moment",
    reply: "Répondre", archive: "Archiver",
    error_login: "Connexion requise", zone_approx: "Zone approx.",
    available: "Disponible", online: "En ligne", public_place: "Lieu public",
  },
  en: {
    nav_discover: "Discover", nav_sessions: "Sessions", nav_messages: "Messages", nav_profile: "Profile",
    discover_search: "What do you need today?", discover_tagline: "Not a date. A real exchange.",
    discover_empty: "We're tuning your Swap.", discover_empty_sub: "Try removing a filter or expanding your zone.",
    discover_empty_cta: "Create a request", discover_restart: "Start over",
    filter_all: "All", filter_offers: "Offers", filter_requests: "Requests", filter_sessions: "Sessions",
    filter_profiles: "Profiles", filter_clear: "Clear", filter_apply: "See results",
    filter_category: "Category", filter_zone: "Zone", filter_format: "Format", filter_duration: "Duration",
    card_skip: "Skip", card_save: "Save", card_ask: "Ask", card_offer: "Offer help",
    card_join: "Join", card_view: "View profile",
    card_type_offer: "Offer", card_type_request: "Request", card_type_session: "Session",
    card_match: "Match:",
    msg_received: "Received", msg_sent: "Sent", msg_active: "Active", msg_archived: "Archived",
    msg_blur_hint: "Message blurred — your choice to open it.",
    msg_reveal: "Read message", msg_accept: "Accept", msg_decline: "Decline",
    msg_block: "Block", msg_report: "Report", msg_delete: "Delete",
    msg_pending_sent: "Request sent. You can continue if they reply.",
    msg_one_request: "One request. No spam.",
    msg_placeholder: "Your message (250 chars max)...",
    msg_empty_received: "No requests received yet.",
    msg_empty_sent: "You haven't sent any request yet.",
    msg_empty_active: "No active conversations.",
    msg_status_pending: "Pending", msg_status_accepted: "Accepted", msg_status_declined: "Declined",
    msg_status_revealed: "Opened", msg_status_blocked: "Blocked",
    req_form_title: "Send a request", req_skill: "Skill", req_goal: "Your goal",
    req_format: "Format", req_duration: "Duration", req_zone: "Zone", req_message: "Message",
    req_send: "Send request", req_cancel: "Cancel",
    session_join: "Join", session_places: "spot(s) left", session_full: "Full",
    session_level: "Level", session_language: "Language", session_host: "Hosted by",
    session_safety: "Public place or online — mutual respect",
    session_filter_title: "Filter sessions",
    profile_edit: "Edit", profile_save: "Save", profile_preview: "Preview",
    profile_skills_offered: "I offer", profile_skills_needed: "I need",
    profile_availability: "Availability", profile_bio: "Bio",
    profile_add_skill: "Add a skill", profile_detail_placeholder: "Optional detail...",
    profile_step_basics: "Basics", profile_step_skills: "Skills", profile_step_zones: "Zones",
    profile_step_preview: "Preview",
    safety_title: "Community Rules",
    safety_tagline: "Not a date. A real exchange. Choose a skill, not a person.",
    landing_hero: "Swap skills. Find useful help. Start in Talence.",
    landing_sub: "A local app to offer what you know, find what you need and join useful mini-sessions nearby.",
    landing_cta1: "Open Swap", landing_cta2: "Offer a skill",
    landing_tagline: "Not a date. A real exchange.",
    landing_how: "How it works", landing_examples: "Exchange examples",
    landing_safety: "Safety", landing_local: "Local pilot",
    how_step1: "Choose what you need", how_step1_sub: "Skills, help, activity, session...",
    how_step2: "Discover profiles", how_step2_sub: "Someone offering or looking.",
    how_step3: "Send a request", how_step3_sub: "Structured message. No spam.",
    how_step4: "Meet online or in person", how_step4_sub: "Campus, public place or video call.",
    admin_title: "Admin — Moderation",
    match_ready: "Swap ready", write_now: "Write now", save_later: "Save for later",
    request_sent: "Request sent", around_you: "Around you", suggestions: "Fresh suggestions",
    reply: "Reply", archive: "Archive",
    error_login: "Login required", zone_approx: "Approx. zone",
    available: "Available", online: "Online", public_place: "Public place",
  }
};